import styled from 'styled-components';
import { ReactComponent as BadgeSvg } from './icons/badge.svg';

export const Section = styled.div`
  width: 100%;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 12px;
`;

export const Row = styled.div`
  display: flex;
  align-items: center;
  gap: 12px;
  width: 100%;
  padding: 4px 0;
  font-family: 'Poppins', sans-serif;
`;

export const BadgeIcon = styled(BadgeSvg)`
  width: 24px;
  height: 24px;
  flex-shrink: 0;

  path {
    fill: #3478d7;
  }
`;

export const Title = styled.span`
  font-size: 16px;
  font-weight: 600;
  color: #1a1a1a;
`;

export const Divider = styled.span`
  display: inline-block;
  width: 1px;
  height: 18px;
  background: #d9d9d9;
`;

export const StatusLabel = styled.span`
  font-size: 14px;
  color: ${({ $isMember }) => ($isMember ? 'rgb(0, 122, 222)' : '#666')};
`;

export const MemberId = styled.span`
  font-size: 14px;
  color: #595559;
  cursor: ${({ $clickable }) => ($clickable ? 'pointer' : 'default')};

  &:hover {
    text-decoration: ${({ $clickable }) => ($clickable ? 'underline' : 'none')};
  }
`;

export const ToggleSpacer = styled.div`
  margin-left: auto;
`;
